/* PAKKS CART DRAWER RUNTIME (Phase 2-D). Vanilla, no libraries, deferred.
   Markup + every number: sections/pk-cart-drawer.liquid → snippets/pk-cart-drawer.liquid (Liquid, Markets prices, native discounts).
   This file only talks to the Shopify Ajax Cart API and swaps the re-rendered section parts (Section Rendering API).

   Public API (used by the product templates and anything else that adds to the cart):
     PakksCart.open({trigger})        open the drawer (trigger = element to return focus to)
     PakksCart.close()
     PakksCart.add(lines, {open})     lines: variant id | {id|variantId, quantity, properties, selling_plan} | an array of those.
                                      Resolves with the /cart/add.js response; rejects on an Ajax error (the message is also shown in the drawer).
                                      open defaults to true.
     PakksCart.refresh()              re-render from the server (call after you changed the cart yourself)
     PakksCart.change(key, qty) / PakksCart.update(updates, attributes)
   Events:
     listens   document/window 'pk:cart:updated'  (detail.source !== 'pk-cart' → refresh; detail.open → open)
               document/window 'pk:cart:open'
     dispatches 'pk:cart:updated' {source:'pk-cart', action, item_count, cart?}  and  'pk:cart-updated' {item_count} (header count, pk-site.js)
               Dawn pubsub cartUpdate when window.publish exists (legacy pages); Shopify.analytics custom event 'pk_cart_offer_added' for upsell taps.
   Also: free gift auto-add/remove (cart attribute _pk_gift = declined when the shopper removes it), Onward Checkout+ (StorefrontClient
   adapter + container), opening the drawer when another script adds to the cart. */
(function () {
  'use strict';
  if (window.PakksCart && window.PakksCart.__pk) return;

  var doc = document, root = doc.documentElement;
  var RM = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var HDR = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Pk-Cart': '1' };
  var el = {}, data = {}, isOpen = false, lastFocus = null, inerted = [], queue = Promise.resolve(), giftLock = false, onwardTried = false;

  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function u(p) { return ROOT.replace(/\/?$/, '/') + String(p).replace(/^\//, ''); }

  /* ---------- elements ---------- */
  function bind() {
    var all = $$('[data-pk-cart]');
    // one drawer per page: if the group and a test template both render one, keep the first
    all.slice(1).forEach(function (d) { var w = d.closest('.shopify-section') || d; if (w.parentNode) w.parentNode.removeChild(w); });
    el.drawer = all[0] || null;
    if (!el.drawer) return false;
    el.panel = $('.pk-cart__panel', el.drawer);
    el.body = $('[data-pk-part="body"]', el.drawer);
    el.foot = $('[data-pk-foot]', el.drawer);
    el.err = $('[data-pk-cart-error]', el.drawer);
    el.title = $('#PkCartTitle', el.drawer);
    el.live = $('[data-pk-cart-live]') || null;
    el.sid = el.drawer.getAttribute('data-section-id');
    readData(el.drawer);
    return true;
  }
  function readData(scope) {
    var j = $('[data-pk-part="data"]', scope);
    try { data = j ? JSON.parse(j.textContent) : {}; } catch (e) { data = {}; }
  }

  /* ---------- network ---------- */
  function post(path, body) {
    return fetch(u(path), { method: 'POST', headers: HDR, body: JSON.stringify(body || {}), credentials: 'same-origin' })
      .then(function (r) {
        return r.text().then(function (t) {
          var j = null; try { j = t ? JSON.parse(t) : {}; } catch (e) { j = {}; }
          if (!r.ok) {
            var msg = (j && (j.description || j.message)) || (r.status === 429 ? 'The cart is a little busy. Please try again in a moment.' : 'Something went wrong. Please try again.');
            var er = new Error(msg); er.status = r.status; er.data = j; throw er;
          }
          return j;
        });
      });
  }
  function withSections(body) {
    if (el.sid) { body.sections = el.sid; body.sections_url = location.pathname + location.search; }
    return body;
  }
  function enqueue(fn) {
    var p = queue.then(fn, fn);
    queue = p.catch(function () {});
    return p;
  }
  function busy(on) {
    if (!el.body) return;
    if (on) el.body.setAttribute('aria-busy', 'true'); else el.body.removeAttribute('aria-busy');
  }
  function fetchSection() {
    var q = new URLSearchParams(location.search); q.set('sections', el.sid);
    // no "Accept: application/json" here: on /products/* Shopify would answer with the product JSON instead of the sections
    return fetch(location.pathname + '?' + q.toString(), { headers: { 'X-Pk-Cart': '1' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('section ' + r.status); return r.json(); })
      .then(function (j) { return j && j[el.sid]; });
  }

  /* ---------- render ---------- */
  function apply(html, action, cart) {
    if (!html || !el.drawer) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pk-cart]');
    if (!fresh) return;
    var a = doc.activeElement, inside = a && el.drawer.contains(a);
    var focusId = inside && a.getAttribute ? a.getAttribute('data-pk-focus') : null;
    var scroll = el.body ? el.body.scrollTop : 0;
    ['count', 'body', 'totals'].forEach(function (n) {
      var to = $('[data-pk-part="' + n + '"]', el.drawer), from = $('[data-pk-part="' + n + '"]', fresh);
      if (to && from) to.innerHTML = from.innerHTML;
    });
    var ff = $('[data-pk-foot]', fresh);
    if (el.foot && ff) el.foot.hidden = ff.hidden;
    var dj = $('[data-pk-part="data"]', el.drawer), fj = $('[data-pk-part="data"]', fresh);
    if (dj && fj) dj.textContent = fj.textContent;
    readData(el.drawer);
    if (el.body) el.body.scrollTop = scroll;
    if (inside) restoreFocus(focusId);
    syncLadder();
    emit(action || 'refresh', cart);
    notifyOnward(cart);
    maybeGift();
  }
  /* Onward keeps its own copy of the cart (premium, "Checkout+ | $X"): hand it every change we make */
  var onwardTimer = null;
  function notifyOnward(cart) {
    var app = window.onwardApp;
    if (!app || typeof app.cartChanged !== 'function' || app.nullified) return;
    clearTimeout(onwardTimer);
    onwardTimer = setTimeout(function () {
      var go = function (c) { try { app.cartChanged(c); } catch (e) {} };
      if (cart && cart.items && cart.currency) go(cart);
      else fetch(u('cart.js'), { headers: { Accept: 'application/json', 'X-Pk-Cart': '1' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(go, noop);
    }, 120);
  }
  function restoreFocus(id) {
    if (!isOpen) return;
    var t = id && $('[data-pk-focus="' + id + '"]', el.drawer);
    if (t && !t.disabled) { t.focus(); return; }
    if (id && /^minus-/.test(id)) { var p = $('[data-pk-focus="' + id.replace(/^minus-/, 'plus-') + '"]', el.drawer); if (p) { p.focus(); return; } }
    var any = $('[data-pk-remove]', el.drawer) || $('.pk-cart-empty a', el.drawer);
    (any || el.title || el.panel).focus();
  }
  function emit(action, cart) {
    var detail = { source: 'pk-cart', action: action, item_count: data.count || 0, cart: cart || null };
    try {
      doc.dispatchEvent(new CustomEvent('pk:cart:updated', { detail: detail }));
      doc.dispatchEvent(new CustomEvent('pk:cart-updated', { detail: { item_count: detail.item_count } }));
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
        window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pk-cart', cartData: cart || null });
      }
    } catch (e) { /* never break the cart for a listener */ }
  }
  function say(msg) {
    if (!el.live || !msg) return;
    el.live.textContent = '';
    setTimeout(function () { el.live.textContent = msg; }, 60);
  }
  function summary(prefix) {
    var n = data.count || 0;
    return (prefix ? prefix + ' ' : '') + (n === 1 ? '1 item in your cart.' : n + ' items in your cart.') + (data.ship && n ? ' ' + data.ship + '.' : '');
  }
  function showError(e) {
    if (el.err) el.err.textContent = (e && e.message) || 'Something went wrong. Please try again.';
  }
  function clearError() { if (el.err) el.err.textContent = ''; }

  /* ---------- cart operations ---------- */
  function normalize(lines) {
    if (lines == null) return [];
    if (!Array.isArray(lines)) lines = [lines];
    return lines.map(function (l) {
      if (typeof l === 'number' || typeof l === 'string') return { id: Number(l), quantity: 1 };
      var o = { id: Number(l.id || l.variantId || l.variant_id), quantity: Number(l.quantity || 1) };
      if (l.properties) o.properties = l.properties;
      if (l.selling_plan || l.sellingPlan) o.selling_plan = Number(l.selling_plan || l.sellingPlan);
      return o;
    }).filter(function (l) { return l.id > 0 && l.quantity > 0; });
  }
  function add(lines, opts) {
    opts = opts || {};
    var items = normalize(lines);
    if (!items.length) return Promise.reject(new Error('Nothing to add'));
    if (!el.drawer) {   // no drawer on this page: plain Ajax add, then the cart page
      return post('cart/add.js', { items: items }).then(function (r) { if (opts.open !== false) location.href = u('cart'); return r; });
    }
    clearError();
    return enqueue(function () {
      busy(true);
      return post('cart/add.js', withSections({ items: items })).then(function (res) {
        busy(false);
        apply(res.sections && res.sections[el.sid], 'add', null);
        if (!opts.silent) say(summary(opts.message || 'Added to your cart.'));
        if (opts.open !== false) open({ trigger: opts.trigger });
        return res;
      }, function (e) {
        busy(false);
        if (!opts.quiet) {
          showError(e);
          if (opts.open !== false) open({ trigger: opts.trigger });
          say(e.message);
        }
        throw e;
      });
    });
  }
  function change(key, qty, opts) {
    opts = opts || {};
    clearError();
    return enqueue(function () {
      busy(true);
      return post('cart/change.js', withSections({ id: key, quantity: qty })).then(function (cart) {
        busy(false);
        apply(cart.sections && cart.sections[el.sid], qty === 0 ? 'remove' : 'change', cart);
        if (!opts.silent) say(summary(qty === 0 ? 'Removed.' : 'Quantity updated.'));
        return cart;
      }, function (e) { busy(false); showError(e); say(e.message); throw e; });
    });
  }
  function update(updates, attributes, opts) {
    opts = opts || {};
    clearError();
    var body = {};
    if (updates) body.updates = updates;
    if (attributes) body.attributes = attributes;
    return enqueue(function () {
      busy(true);
      return post('cart/update.js', withSections(body)).then(function (cart) {
        busy(false);
        apply(cart.sections && cart.sections[el.sid], opts.action || 'update', cart);
        if (!opts.silent) say(summary(opts.message || 'Cart updated.'));
        return cart;
      }, function (e) { busy(false); showError(e); say(e.message); throw e; });
    });
  }
  function refresh(opts) {
    opts = opts || {};
    if (!el.drawer) return Promise.resolve();
    return enqueue(function () {
      return fetchSection().then(function (html) {
        apply(html, opts.action || 'refresh', null);
        if (opts.announce) say(summary(opts.announce));
      }).catch(function () { /* offline etc.: keep what we have */ });
    });
  }
  var refreshTimer = null;
  function refreshSoon(opts) { clearTimeout(refreshTimer); refreshTimer = setTimeout(function () { refresh(opts); }, 200); }

  /* ---------- free gift (replaces EG Auto Add to Cart; off unless the section setting is on) ---------- */
  function maybeGift() {
    var g = data.gift;
    if (!g || !g.on || !g.variant || giftLock) return;
    var reached = (data.eligible || 0) >= (g.threshold || 0) && (g.threshold || 0) > 0;
    var job = null;
    if (reached && !g.key && !g.declined && g.available && data.count > 0) {
      job = function () { return add([{ id: g.variant, quantity: 1 }], { open: false, silent: true, quiet: true }).then(function () { say('A free gift was added to your cart.'); }); };
    } else if (!reached && g.key) {
      job = function () { return change(g.key, 0, { silent: true }).then(function () { say('The free gift was removed from your cart.'); }); };
    } else if (g.key && g.qty > 1) {
      job = function () { return change(g.key, 1, { silent: true }); };
    }
    if (!job) return;
    giftLock = true;
    setTimeout(function () { job().catch(function () {}).then(function () { giftLock = false; }); }, 0);
  }

  /* ---------- ladder quick picker ---------- */
  function syncLadder() {
    if (!el.drawer) return;
    var r = $('input[name="pk-cart-deck"]:checked', el.drawer);
    var sr = $('[data-pk-ladder-sr]', el.drawer), picked = $('[data-pk-ladder-picked]', el.drawer);
    var name = r ? r.getAttribute('data-name') : '';
    if (sr) sr.textContent = name ? ' ' + name : '';
    if (picked) picked.textContent = name;
  }

  /* ---------- open / close ---------- */
  // app overlays that open on top of the drawer and must stay usable (Onward's info modal lives in a shadow host on <body>)
  var KEEP_LIVE = '.onward-modal-shadow-host, [class*="onward-modal"]';
  function foreignModalOpen() {
    try { if (doc.querySelector('dialog[open]:modal')) return true; } catch (e) {}
    return $$(KEEP_LIVE).some(function (h) { return h.shadowRoot && h.shadowRoot.querySelector('dialog[open]'); });
  }
  function setInert(on) {
    if (on) {
      var keep = el.drawer.closest('.shopify-section') || el.drawer;
      inerted = [];
      Array.prototype.forEach.call(doc.body.children, function (n) {
        if (n === keep || n.contains(el.drawer) || n.contains(el.live) || n.tagName === 'SCRIPT' || n.inert || n.matches(KEEP_LIVE)) return;
        n.inert = true; inerted.push(n);
      });
    } else {
      inerted.forEach(function (n) { n.inert = false; });
      inerted = [];
    }
  }
  function open(opts) {
    opts = opts || {};
    if (!el.drawer && !bind()) { location.href = u('cart'); return; }
    if (isOpen) { if (opts.focus !== false) el.panel.focus(); return; }
    lastFocus = opts.trigger || doc.activeElement;
    el.drawer.hidden = false;
    isOpen = true;
    root.classList.add('pk-cart-locked');
    setInert(true);
    mountOnward();
    // two frames so the slide-in transition runs; the timeout covers tabs where rAF is paused (background / prerender)
    var shown = false, show = function () { if (shown || !isOpen) return; shown = true; el.drawer.classList.add('is-open'); el.panel.focus(); };
    requestAnimationFrame(function () { requestAnimationFrame(show); });
    setTimeout(show, 80);
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    el.drawer.classList.remove('is-open');
    root.classList.remove('pk-cart-locked');
    setInert(false);
    var d = el.drawer;
    var done = function () { if (!isOpen) d.hidden = true; };
    if (RM) done(); else setTimeout(done, 320);
    var back = lastFocus && doc.contains(lastFocus) && lastFocus !== doc.body ? lastFocus : $('[data-pk-cart-toggle]');
    if (back && back.focus) back.focus();
  }
  function focusables() {
    return $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', el.panel)
      .filter(function (x) { return x.offsetParent !== null || x.getClientRects().length; })
      .filter(function (x) { return !(x.type === 'radio' && !x.checked && $$('input[name="' + x.name + '"]:checked', el.panel).length); });
  }

  /* ---------- events ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-pk-cart-toggle]');
    if (t && el.drawer) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;   // new tab: let the /cart link work
      e.preventDefault(); e.stopPropagation();
      if (isOpen) close(); else { open({ trigger: t }); refresh(); }
    }
  }, true);   // capture: wins over Dawn's own cart-drawer listener on legacy pages

  doc.addEventListener('click', function (e) {
    if (!el.drawer || !el.drawer.contains(e.target)) return;
    var b;
    if ((b = e.target.closest('[data-pk-cart-close]'))) { e.preventDefault(); close(); return; }
    if ((b = e.target.closest('[data-pk-qty]'))) { e.preventDefault(); change(b.getAttribute('data-key'), Math.max(0, parseInt(b.getAttribute('data-pk-qty'), 10) || 0)).catch(noop); return; }
    if ((b = e.target.closest('[data-pk-remove]'))) {
      e.preventDefault();
      var key = b.getAttribute('data-key');
      if (b.hasAttribute('data-pk-gift')) update(objOf(key, 0), { _pk_gift: 'declined' }, { action: 'remove', message: 'Removed.' }).catch(noop);
      else change(key, 0).catch(noop);
      return;
    }
    if ((b = e.target.closest('[data-pk-add]'))) { e.preventDefault(); offerAdd(b, b.getAttribute('data-pk-add')); return; }
    if ((b = e.target.closest('[data-pk-ladder-add]'))) {
      e.preventDefault();
      var r = $('input[name="pk-cart-deck"]:checked', el.drawer) || $('input[name="pk-cart-deck"]', el.drawer);
      if (r) offerAdd(b, r.value, r.getAttribute('data-name'));
      return;
    }
    if ((b = e.target.closest('[data-pk-swap]'))) {
      e.preventDefault();
      var up = {}; up[b.getAttribute('data-pk-swap-key')] = parseInt(b.getAttribute('data-pk-swap-keep'), 10) || 0;
      var addId = b.getAttribute('data-pk-swap-add');
      track('upgrade', addId);
      up[addId] = 1;
      // one request: drop one Original (by line key) and add one Ultimate (by variant id) in the same /cart/update.js
      update(up, null, { action: 'swap', message: 'Upgraded to the Ultimate.' })
        .then(function () { var f = $('[data-pk-remove]', el.drawer); if (f) f.focus(); })
        .catch(noop);
      return;
    }
  });
  doc.addEventListener('change', function (e) { if (e.target && e.target.name === 'pk-cart-deck') syncLadder(); });
  doc.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') {
      if (e.defaultPrevented || foreignModalOpen()) return;   // Onward's info modal closes itself first
      e.preventDefault(); close(); return;
    }
    if (e.key !== 'Tab' || foreignModalOpen()) return;   // a native modal on top traps focus itself
    var f = focusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = doc.activeElement;
    if (!el.panel.contains(a) || a === el.panel || a === el.title) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
    else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  });
  function objOf(k, v) { var o = {}; o[k] = v; return o; }
  function noop() {}
  function offerAdd(btn, id, name) {
    var kind = btn.getAttribute('data-pk-offer-name') || 'offer';
    track(kind, id);
    btn.setAttribute('aria-disabled', 'true');
    add([{ id: id, quantity: 1 }], { open: false, message: (name ? name + ' added.' : 'Added to your cart.') }).catch(noop)
      .then(function () { btn.removeAttribute('aria-disabled'); });
  }
  function track(kind, id) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('pk_cart_offer_added', { offer: kind, variant_id: String(id) }); } catch (e) {}
  }

  function onExternal(e) {
    var d = (e && e.detail) || {};
    if (d.__pkSeen || d.source === 'pk-cart') return;
    d.__pkSeen = true;
    if (d.open) open({ trigger: d.trigger });
    refresh({ action: 'external' });
  }
  doc.addEventListener('pk:cart:updated', onExternal);
  window.addEventListener('pk:cart:updated', onExternal);
  function onOpen(e) { var d = (e && e.detail) || {}; if (d.__pkSeen) return; d.__pkSeen = true; open({ trigger: d.trigger }); refresh(); }
  doc.addEventListener('pk:cart:open', onOpen);
  window.addEventListener('pk:cart:open', onOpen);

  /* Other scripts (apps, GemPages, Dawn product forms) that change the cart: refresh, and open on an add. */
  // only open for an add the shopper just asked for (a tap/key/submit in the last few seconds), never for an app adding a gift on page load
  var lastGesture = 0;
  ['pointerdown', 'keydown', 'submit'].forEach(function (t) { doc.addEventListener(t, function () { lastGesture = Date.now(); hookGemPages(); }, true); });
  /* GemPages product buttons with "open cart drawer": after their /cart/add they call window.GPF.openCartDrawer if it exists,
     otherwise Dawn's <cart-drawer>, otherwise they redirect to /cart. Dawn's drawer is gone, so give them ours. */
  function hookGemPages() {
    var G = window.GPF = window.GPF || {};
    if (typeof G.openCartDrawer === 'function' && !G.openCartDrawer.__pk) return;   // GemPages' own handler wins if it ever ships one
    var f = function () { if (!el.drawer && !bind()) { location.href = u('cart'); return; } open(); refresh({ action: 'external' }); };
    f.__pk = true;
    G.openCartDrawer = f;
  }
  hookGemPages();
  function external(isAdd) {
    var onwardBusy = window.onwardClient && window.onwardClient.onwardNetworkCallHappening;
    refreshSoon({ action: 'external' });
    if (isAdd && !isOpen && !onwardBusy && Date.now() - lastGesture < 5000 && data.openOnExternalAdd !== false && el.drawer && !$('cart-drawer, cart-notification')) open();
  }
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  (function watchFetch() {
    var of = window.fetch;
    if (!of || of.__pkWrapped) return;
    var w = function (input, init) {
      var p = of.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var h = (init && init.headers) || (input && input.headers);
        var mine = h && (typeof h.get === 'function' ? h.get('X-Pk-Cart') : h['X-Pk-Cart']);
        if (!mine && CART_RE.test(url)) p.then(function (r) { if (r && r.ok) external(/\/cart\/add/.test(url)); }, noop);
      } catch (e) {}
      return p;
    };
    w.__pkWrapped = true;
    window.fetch = w;
  })();
  (function watchXhr() {
    var X = window.XMLHttpRequest; if (!X || X.prototype.__pkWrapped) return;
    var o = X.prototype.open;
    X.prototype.open = function (m, url) {
      try { if (CART_RE.test(String(url))) { var isAdd = /\/cart\/add/.test(String(url)); this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) external(isAdd); }); } } catch (e) {}
      return o.apply(this, arguments);
    };
    X.prototype.__pkWrapped = true;
  })();

  /* ---------- Onward Checkout+ (theme app embed + JS SDK) ----------
     Defensive: nothing shows unless the Onward embed is running (window.initializeOnward + OnwardSettingsJson.shopEnabled).
     We mount Onward's widget in #pk-onward (it must be EMPTY when mounted) with our own StorefrontClient (Ajax API), and in
     "checkout_plus" mode let OnwardSetup turn our checkout button into "Checkout+ | $X" + "Continue without" (as on the live cart).
     The protection line is added by Onward when checkout is pressed; if it is in the cart, Liquid shows it as "Shipping protection"
     in the totals and leaves it out of the free-shipping maths. Metadata goes in cart attributes, never line properties (Onward may
     clear and re-add the cart). */
  function parseCart(c) {
    c = c || {};
    return {
      currency: c.currency || null,
      items: (c.items || []).map(function (i) {
        var sp = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan && i.selling_plan_allocation.selling_plan.id;
        return {
          cost: { amount: i.final_line_price / 100, currencyCode: c.currency },
          allocatedCost: { amount: i.line_price / 100, currencyCode: c.currency },
          preDiscountCost: { amount: i.original_line_price / 100, currencyCode: c.currency },
          quantity: i.quantity,
          properties: i.properties || null,
          sellingPlanIdentifier: sp != null ? String(sp) : null,
          variant: { price: null, requiresShipping: i.requires_shipping, id: i.variant_id }
        };
      })
    };
  }
  function PakksOnwardClient(handle) { this.handle = handle || 'onward-package-protection'; }
  PakksOnwardClient.prototype.fetchCart = function () {
    return fetch(u('cart.js'), { headers: { Accept: 'application/json', 'X-Pk-Cart': '1' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(parseCart);
  };
  PakksOnwardClient.prototype.addCartLines = function (lines) {
    var self = this;
    var items = (lines || []).map(function (l) {
      var o = { id: Number(l.variantId), quantity: l.quantity };
      if (l.properties) o.properties = l.properties;
      if (l.sellingPlanIdentifier) o.selling_plan = Number(l.sellingPlanIdentifier);
      return o;
    });
    return post('cart/add.js', { items: items }).then(function () { refreshSoon({ action: 'onward' }); return self.fetchCart(); });
  };
  PakksOnwardClient.prototype.updateCartLines = function (lines) {
    var up = {};
    (lines || []).forEach(function (l) { up[String(l.variantId)] = l.quantity; });
    return post('cart/update.js', { updates: up }).then(function (c) { refreshSoon({ action: 'onward' }); return parseCart(c); });
  };
  PakksOnwardClient.prototype.clearCart = function () {
    return post('cart/clear.js', {}).then(function (c) { refreshSoon({ action: 'onward' }); return parseCart(c); });
  };
  PakksOnwardClient.prototype.updateCartAttributes = function (attrs) {
    return post('cart/update.js', { attributes: attrs || {} }).then(parseCart);
  };
  PakksOnwardClient.prototype.fetchInsuranceProduct = function () {
    return fetch(u('products/' + this.handle + '.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('Failed to fetch insurance product.'); return r.json(); })
      .then(function (p) {
        return {
          featuredImage: p.featured_image,
          variants: (p.variants || []).map(function (v) {
            return { id: String(v.id), price: { amount: v.price / 100, currencyCode: null },
              sellingPlanIdentifiers: (v.selling_plan_allocations || []).map(function (a) { return a.selling_plan_id != null ? String(a.selling_plan_id) : null; }) };
          })
        };
      });
  };

  function mountOnward() {
    var mode = data.onward && data.onward.mode;
    if (!el.drawer || !mode || mode === 'off') return;
    var box = $('[data-pk-onward]', el.drawer);
    if (!box || box.__pkMounted || box.childNodes.length) return;
    var S = window.OnwardSettingsJson;
    if (typeof window.initializeOnward !== 'function' || !S || S.shopEnabled === false) return;   // not installed / not loaded yet
    try {
      var app = window.onwardApp;
      if (app && app.vueApps && app.vueApps.length && !app.nullified && typeof app.mountWidgets === 'function') {
        app.mountWidgets([box]);   // another Onward mount already lives on this page (e.g. the cart page): share it
      } else {
        window.initializeOnward(true, '#pk-onward', new PakksOnwardClient());
      }
      box.__pkMounted = true;
      if (mode === 'checkout_plus' && S.checkoutPlusEnabled && window.OnwardSetup && !onwardTried) {
        onwardTried = true;
        new window.OnwardSetup(doc).attachCheckoutButton('[data-pk-checkout]', { optOutSelector: '[data-pk-optout]', optOutPosition: 'beforeend', optOutCustomClasses: 'pk-cart__optout' });
      }
    } catch (e) {
      box.__pkMounted = false;
      if (window.console) console.warn('[pk-cart] Onward not mounted', e);
    }
  }
  window.addEventListener('onward:loaded', function () { if (isOpen) mountOnward(); });
  // "Widget only" mode: Onward doesn't hook our button, so add/remove the protection line ourselves before checkout
  doc.addEventListener('submit', function (e) {
    var f = e.target, app = window.onwardApp;
    if (!el.drawer || !el.drawer.contains(f) || !data.onward || data.onward.mode !== 'widget') return;
    if (!app || typeof app.updateCartForCheckout !== 'function' || !app.vueApps || !app.vueApps.length) return;
    e.preventDefault();
    Promise.resolve().then(function () { return app.updateCartForCheckout(); }).catch(noop).then(function () { location.href = u('checkout'); });
  }, true);

  /* ---------- theme editor ---------- */
  doc.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector('[data-pk-cart]')) { var was = isOpen; isOpen = false; bind(); if (was) open(); } });
  doc.addEventListener('shopify:section:select', function (e) { if (e.target && e.target.querySelector('[data-pk-cart]')) open(); });
  doc.addEventListener('shopify:section:deselect', function (e) { if (e.target && e.target.querySelector('[data-pk-cart]')) close(); });

  /* ---------- boot ---------- */
  function boot() {
    bind();
    syncLadder();
    maybeGift();
    // warm Onward up while idle, so the widget is ready when the drawer opens
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1500); };
    idle(function () { if (data && !data.empty) mountOnward(); });
    // back/forward cache: the cart may have changed in another tab
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();

  window.PakksCart = {
    __pk: true,
    open: function (o) { open(o); },
    close: close,
    add: add,
    change: change,
    update: update,
    refresh: refresh,
    get data() { return data; },
    get isOpen() { return isOpen; },
    OnwardClient: PakksOnwardClient
  };
})();
